<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>充值</h4>
      <div @click="backClick"><i class="fa fa-reply"></i></div>
      <!-- <el-button  size='mini' type="text" @click="backClick">返回</el-button> -->
    </div>
     <el-tabs  v-model="editableTabsValue" type="card"  style="margin-left:10px;"  @tab-click="handleClick">
      <el-tab-pane label="银行卡" name="first">
        <div>
          <div class="title">充值说明</div>
          <p class="content">• &nbsp;对资金账户充值，必须使用资金账户中添加的充值银行卡进行网银转账或汇款。</p>
          <p class="content">• &nbsp;充值到以下账号：</p>
          <table border="1"  class="table">
            <tr >
              <td  width='100' >开户名称</td>
              <td width='500' >{{payData.accountName}}</td>
            </tr>
            <tr >
              <td width='100' >开户银行</td>
              <td width='500' >{{payData.openBankName}}</td>
            </tr>
             <tr >
              <td width='100'>银行账号</td>
              <td width='500'>{{payData.accountNo}}</td>
            </tr>
          </table>
        </div>
        <div>
          </br>
          <div class="title">常见问题</div>
          <p class="content">• &nbsp;到账时间</p>
          <span class="content">&nbsp;&nbsp;工作日2小时内到账，非工作日2小时内到账。</span></br>
          <span class="content">&nbsp;&nbsp;节假日到账时间按非工作日处理，如若充值资金长时间未到账，请致电客服热线：400-8989-256</span>
          <p class="content">• &nbsp;充值银行选择</p>
          <span class="content">&nbsp;&nbsp;为确保银行的处理时效，建议使用国有银行(如:中农工建交）或大众银行（如:招商、浦发、广发）等常用的银行，请避免使用农村商业银行等地方性的小众银行</span>
          <p class="content">• &nbsp;充值记录查看</p>
          <span class="content">&nbsp;&nbsp;转账资金到账后，可通过“钱包-钱包首页”中的“钱包账户-可用余额”以及报表或钱包明细（app）查询充值到账详情</span>
          <p class="content">• &nbsp;关于误操作</p>
          <span class="content">&nbsp;&nbsp;如若转账错误，银行会在24小时内把对应资金退返回原账户，特殊情况请及时咨询各银行的客服热线</span>
        </div>
        <!-- <el-button  size='mini' type="primary" @click="backClick">返回</el-button> -->
      </el-tab-pane>
      <!-- <el-tab-pane label="微信" name="second">
        <div>
          <p>输入充值金额：</p>
          <p>
            <el-input size="mini" placeholder="请输入金额点击确定扫码充值" v-number-input.float="3" maxlength=""  v-model.trim="money" style="width:220px;"></el-input>
            &nbsp;&nbsp;
            <el-button  size='mini' type="primary" @click="submit" :loading='submitLoading' v-if="submitDisabled">确定</el-button>
          </p>
        </div>
        <div>
          <span>请输入金额点击确定扫码充值，充值完成后请点击返回</span>
        </div>
        <div v-if="show">
          <qriously :value="initQCode" :size="138" />
        </div>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>
<script>
import {
  wxNativePayUrl, // 二维码支付
  getChongzhiAccount
} from '@/api/consignment'
import DonMessage from '@/utils/message'
// eslint-disable-next-line no-unused-vars
import { getBtn } from '@/utils/getButton'
// eslint-disable-next-line no-unused-vars
import store from '@/store'
export default {
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ['00DP003B001', '00DP003B002', '00DP003B003',
        '00DP003B004', '00DP003B005', '00DP003B006'],
      activeName: 'first',
      editableTabs: [],
      editableTabsValue: 'first',
      title: '',
      h: '500px',
      total: 0,
      searchFrom1: {
        defaultCno: '',
        pageNo: 1,
        pageSize: 10
      },
      money: '',
      initQCode: '',
      show: false,
      submitLoading: false,
      submitDisabled: true,
      backDisabled: false,
      payData: {}
    }
  },
  mounted () {
    // let h = this.$refs.searchBox.offsetHeight
    // let pH = document.documentElement.clientHeight
    // this.h = (pH - h - 150) + 'px'
    this.submitLoading = true
    getChongzhiAccount().then(res => {
      this.submitLoading = false
      this.payData = res
    })
  },
  created () {
    // this.getListData()
    // this.btnFlg = getBtn(this.btnIdArr, '/waybillManagement')
  },
  methods: {
    // 点击tab
    handleClick (tab, event) {
    },
    // 返回
    backClick () {
      this.$router.push('/payCustomer/capital')
    },
    submit () {
      this.submitLoading = true
      wxNativePayUrl({
        money: this.money,
        costId: localStorage.getItem('accountId')
      }).then(res => {
        this.initQCode = res
        this.show = true
        this.submitLoading = false
        this.submitDisabled = false
        // this.backDisabled = true
      }).catch(err => {
        this.submitLoading = false
        DonMessage.error(err.message)
      })
    }

  }
}
</script>
<style scoped lang='less'>
/deep/ .el-tabs__item {
  width:150px;
  text-align: center;
  // background-color:#ccc ;
}
/deep/ .is-active{
  background-color:#0e6eec;
  color: #fff;
}
.title{
  font-size: 18px;
}
.content{
  margin-left: 20px;
}
.table{
  border-collapse: collapse;
  margin-left: 20px;
  td{
    height:40px;
    text-align: center;
  }
}
.inpBox{
  margin: 10px 0 0 -30px;
}

 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.searchBtnBox{
  margin-top: 10px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width:  280px;
    background-color:#fff;
}
.searchBtnBox{
  margin-top: 10px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
</style>
